App.filter('hideBranchCargo', ['Configurator', function (Configurator) {
    return function (branches) {
        if (Configurator.authPrefix === "cargo.xilium.pl:") {
            return _.filter(branches, function (branch) { return branch.name !== 'Cargo'});
        } else if (Configurator.authPrefix === "cargotabor.xilium.pl:") {
            return _.filter(branches, function (branch) { return branch.name !== 'CargoTabor'});
        } else {
            return branches;
        }
    };
}])